import React,{useState,useEffect} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import {sliderData} from '../data/homeData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiChevronLeft,FiChevronRight}=FiIcons;

export default function HeroSlider({onExplore}) {
  const [current,setCurrent]=useState(0);

  useEffect(()=> {
    const timer=setInterval(()=> {
      setCurrent((prev)=> (prev===sliderData.length - 1 ? 0 : prev + 1));
    },6000);

    return ()=> clearInterval(timer);
  },[]);

  const nextSlide=()=> setCurrent(current===sliderData.length - 1 ? 0 : current + 1);
  const prevSlide=()=> setCurrent(current===0 ? sliderData.length - 1 : current - 1);

  return (
    <div className="relative h-[70vh] md:h-[85vh] w-full overflow-hidden bg-zinc-950">
      <AnimatePresence mode="wait">
        <motion.div
          key={current}
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          transition={{duration: 1}}
          className="absolute inset-0"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/60 to-transparent z-10" />
          <img
            src={sliderData[current].image}
            alt={sliderData[current].title}
            className="h-full w-full object-cover object-center"
          />

          <div className="absolute inset-0 z-20 flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <motion.div
                initial={{x: -50,opacity: 0}}
                animate={{x: 0,opacity: 1}}
                transition={{delay: 0.3,duration: 0.8}}
                className="max-w-2xl"
              >
                <span className="text-red-600 font-black tracking-[0.2em] uppercase text-sm mb-4 block">
                  {sliderData[current].subtitle}
                </span>
                <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight tracking-tighter">
                  {sliderData[current].title}
                </h1>
                <p className="text-zinc-300 text-lg md:text-xl mb-8 leading-relaxed max-w-lg">
                  {sliderData[current].description}
                </p>
                <button
                  onClick={()=> onExplore(sliderData[current].destination)}
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-xl shadow-red-600/20"
                >
                  {sliderData[current].cta}
                </button>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      <div className="absolute bottom-10 right-10 z-30 flex gap-4">
        <button
          onClick={prevSlide}
          className="p-3 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full text-white transition-all"
          aria-label="Anterior"
        >
          <SafeIcon icon={FiChevronLeft} className="w-6 h-6" />
        </button>
        <button
          onClick={nextSlide}
          className="p-3 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full text-white transition-all"
          aria-label="Siguiente"
        >
          <SafeIcon icon={FiChevronRight} className="w-6 h-6" />
        </button>
      </div>

      <div className="absolute bottom-10 left-10 z-30 flex gap-2">
        {sliderData.map((_,idx)=> (
          <div
            key={idx}
            className={`h-1.5 transition-all duration-500 rounded-full ${idx===current ? 'w-12 bg-red-600' : 'w-3 bg-white/30'}`}
          />
        ))}
      </div>
    </div>
  );
}